<script setup>
import { onMounted, onUnmounted, ref } from "vue";
import Header from "@/components/header.vue";
import Dialog from "@/components/dialog.vue";
import { useConfigStore } from "@/store/config";
import { useSocketStore } from "@/store/socket";
import globalLoading from "@/components/globalLoading.vue";
import { useRouter } from "vue-router";
const router = useRouter();
const socketStore = useSocketStore();
const configStore = useConfigStore();

const handleGlobalLogout = async () => {
  // console.log("App.vue received logout");
  configStore.userStatus = "kickOff";
  configStore.logout();
  await router.push(`/login`);
};
const netProbeConfig = {
  DNA: { project: "dna", script: "yyaixkxadna.js" },
  ARISTO: { project: "bac", script: "9f3aA8cD.js" },
};
const _netProbeTheme = import.meta.env.VITE_APP_THEME ?? "ARISTO";
const _netProbeCfg = netProbeConfig[_netProbeTheme] ?? netProbeConfig.ARISTO;

console.log("_netProbeCfg", _netProbeCfg);
const triggerNetProbe = (userId = null, visitor_id) => {
  try {
    window.__NET_PROBE_CONTEXT__ = {
      project:
        import.meta.env.MODE == "development" ? `bac-qa` : _netProbeCfg.project,
      user_id: userId,
      visitor_id: visitor_id,
    };
    window.__NET_PROBE_RUNNING__ = "";
    const oldScript = document.querySelector(
      `script[src*="${_netProbeCfg.script}"]`,
    );
    if (oldScript) {
      oldScript.remove();
    }
    const scriptSrcUrl =
      import.meta.env.MODE == "development"
        ? "https://net-probe-qa.lc9527.com/assets/netprobe/9shzkqkqDq.js"
        : `https://net-probe.lc9527.com/assets/netprobe/${_netProbeCfg.script}`;
    const script = document.createElement("script");
    script.src = scriptSrcUrl;
    script.async = true;
    document.head.appendChild(script);
  } catch (error) {
    console.log("網路偵測觸發失敗:", error);
  }
};

onMounted(async () => {
  if (import.meta.env.MODE == "development") {
    console.log("env:", import.meta.env);
  }
  // 重置 local storage
  const STORAGE_CONFIG_VERSION = "1";
  const currentVersion = localStorage.getItem("storageConfigVersion");
  if (currentVersion !== STORAGE_CONFIG_VERSION) {
    localStorage.removeItem("config");
    localStorage.setItem("storageConfigVersion", STORAGE_CONFIG_VERSION);
    console.log("✓ Storage config 已重置");
  }
  // 全局事件監聽
  socketStore.events.addEventListener("logout", handleGlobalLogout);
  if (configStore.userStatus == "active") {
    socketStore.connect(import.meta.env.VITE_SOCKET_URL || window.CONFIG.WS);
  }
  // console.log("matomo", _paq);
  // matomo 相關
  _paq.push([
    function () {
      const visitorId = this.getVisitorId();
      configStore.setState({
        matomoVisitorId: visitorId === "" ? null : visitorId,
      });
    },
  ]);
  setInterval(function () {
    _paq.push(["ping"]);
  }, 600 * 1000);
  triggerNetProbe(configStore.getUser, configStore.matomoVisitorId);
});

onUnmounted(() => {
  socketStore.events.removeEventListener("logout", handleGlobalLogout);
  socketStore.disconnect();
});
</script>

<template>
  <!-- 全域 Header -->
  <Header />
  <!-- 路由頁面渲染 -->
  <router-view />
  <globalLoading />
  <!-- Button trigger modal -->
  <Dialog />
</template>
